import React from "react";

export default function Term_and_condition() {
  return (
    <div className=" w-full h-full midnight-navy-300 text-white px-[10%] overflow-auto">
      <div className="Syne700 text-4xl pt-[6%] text-center">
        <h1 className="">SCROLLX TERMS OF SERVICE</h1>
        {/* <h3 className="py-1">SCROLLX TERMS OF SERVICE</h3> */}
      </div>
      <div className="px-[10%] py-4 text-center">
        <p className="py-2">
          These ‘Terms of Service’ (“Terms”) are effective as of 22nd December
          2023. Any amendments or updates to it would be duly reflected here.
        </p>
        <p>
          These Terms apply to your (“you”/ “your”/ “User(s)”) use of ScrollX’s
          credits generating platform (the “Service”). By using the Service, you
          agree that these Terms will become a legally binding agreement between
          you and ScrollX Private Limited(having its registered address at Shade
          No. 8, Industrial Area, Zone-1, M.P. Nagar, Bhopal M.P., India,
          462011) (hereinafter referred to as “ScrollX”/ “we”/ “us”).
        </p>
      </div>
      <div className="FontFamily-Avenir-reg text-lg px-[5%] drop-shadow-2xl midnight-navy-250 py-5">
        {/* 1.	INTRODUCTION  */}
        <div className="grid  grid-flow-row gap-4 list-decimal list-outside py-5">
          <div className="Syne700 text-2xl flex">
            <h1 className="pr-5">1</h1>
            <h1>INTRODUCTION </h1>
          </div>
          <div className="flex">
            <p className="pr-5">(a)</p>
            <p className="">
              ScrollX provides a platform (Software as a Service) dedicated to
              the simplification and generation of credits in all forms of
              visual works including but not limited to motion pictures,
              television, and other multimedia/audio-visualprojects (“Projects”)
              through a variety of rendering options (each a “Design(s)”).When
              you use the Service, you will have access to a variety of Designs
              which you can customise by adding in your own content in the form
              of names, videos, images, and files (“User Content”), which you
              have full control and responsibility over.
            </p>
          </div>
          <div className="flex">
            <p className="pr-5">(b)</p>
            <p>
              The User will input the User Content of the contributors of the
              Project, allowing the User to manipulate the Design through an
              online browser and thereafter Credits will be generated in various
              formats provided by ScrollX which can be added to the User’s
              Projects.
            </p>
          </div>
          <div className="flex">
            <p className="pr-5">(c)</p>
            <p>
              The Service is made available on{" "}
              <span className="text-blue-700">https://www.scrollx.io/</span>
            </p>
          </div>
        </div>
        {/*2. DEFINITIONS */}
        <div className="grid  grid-flow-row gap-4 list-decimal list-outside py-5">
          <div className="Syne700 text-2xl flex">
            <h1 className="pr-5">2</h1>
            <h1>DEFINITIONS</h1>
          </div>
          <div className="flex">
            <p className="pr-5">(a)</p>
            <p className="">
              “APPLICABLE LAWS” means all laws, brought into force and effect by
              the Government of India or the State Government including rules,
              regulations and notifications made thereunder, and judgments,
              decrees, injunctions, writs and orders of any court of record,
              applicable to this Agreement and the exercise, performance and
              discharge of the respective rights and obligations of the Parties
              hereunder, as may be in force and effect during the subsistence of
              this Agreement.
            </p>
          </div>
          <div className="flex">
            <p className="pr-5">(b)</p>
            <p>
              “FEES” means the fees payable by the User for availing the
              Services.
            </p>
          </div>
          <div className="flex">
            <p className="pr-5">(c)</p>
            <p>
              “FORCE MAJEURE” shall mean the occurrence of any unforeseen event
              or act which includes but is not limited to act of God, war,
              failure of internet and telecommunication or any act or event on
              account of any Government Instrumentality which affects ScrollX’s
              performance of its obligations under this Agreement which act or
              event(i) is beyond the reasonable control of ScrollX, and (ii)
              ScrollX could not have prevented or overcome by exercise of
              ordinary due diligence
            </p>
          </div>
          <div className="flex">
            <p className="pr-5">(d)</p>
            <p>
              “INTELLECTUAL PROPERTY” means all patents, trademarks, service
              marks, logos, get-ups, trade names, internet domain names, rights
              in designs, programs and manuals, drawings, copyright (including
              rights in computer software), database rights, rights in know-how
              and other intellectual property rights, in each case whether
              registered or unregistered and including applications for
              registration, and all rights or forms of protection having
              equivalent or similar effect anywhere in the world.
            </p>
          </div>
          <div className="flex">
            <p className="pr-5">(e)</p>
            <p>
              “USER(S)” shall mean and include the following:
              <br />
              i. Any user accessing the website of ScrollX; or
              <br />
              ii. Any user who avails Services of ScrollX; and
              <br />
              iii. Any user submitting its information/data on the website
              ScrollX.
            </p>
          </div>
        </div>
        {/*3.	USING THE SERVICE*/}
        <div className="grid  grid-flow-row gap-4 list-decimal list-outside py-5">
          <div className="Syne700 text-2xl flex">
            <h1 className="pr-5">3</h1>
            <h1>USING THE SERVICE</h1>
          </div>
          <div className="flex">
            <p className="pr-5">(a)</p>
            <p className="">
              <span>LEGAL CAPACITY</span> <br />
              You may use the Service only if you can form a binding contract
              with ScrollX and are legally permitted to do so in the country of
              Applicable Laws (defined thereafter in the Clause 3(d)). By using
              the Service, you represent and warrant that you have the full
              right, power, and authority to agree to and be bound by these
              Terms and to fully perform all your obligations hereunder. If a
              user is entering into these terms for/on behalf of an entity, such
              as a company or institution they work for or are otherwise an
              Associate or Affiliate with the said entity, the user represents,
              acknowledges, and agrees that they have requisite legal authority
              to bind that entity in this Agreement. In all such cases the term
              “User” will be deemed to include the entity that it represents.
            </p>
          </div>
          <div className="flex">
            <p className="pr-5">(b)</p>
            <p className="">
              <span>ACCEPTANCE</span> <br />
              By using the Service, you agree to be bound by these Terms with
              ScrollX in addition to ScrollX’s Privacy Policy. The following
              activities shall constitute usage by you: <br />
              i. Accessing the website/application of ScrollX; or <br />
              ii. Feeding information, of any nature, on the
              website/application; or <br />
              iii. Downloading the assets/credits generated by ScrollX; or{" "}
              <br />
              iv. Clicking the “I Agree” button while signing up.
            </p>
          </div>
          <div className="flex">
            <p className="pr-5">(c)</p>
            <p className="">
              <span>ACCESS TO THE SERVICE</span> <br />
              In order to avail Services/generate Credits, youare required to
              create an account. The access and control of the said account lies
              solely with you and as such you shall be solely responsible for
              the usage and acts performed via the said account. It is hereby
              clarified that the handling and usage of the said account is
              solely your responsibility and as such all measures shall be
              undertaken by you to protect your account from unauthorised and/or
              illegal use.You may not allow any other party to access or use the
              Service with your unique username, password, or other security
              code.ScrollX disclaims all liability and responsibility for the
              wrongful and unauthorised use of your account.
              <p className="pt-3">
                Subject to your compliance with these Terms, you are granted a
                non-exclusive, limited, non-transferable, freely revocable
                license to access and use the Service for business or personal
                use. ScrollX reserves all rights not expressly granted under
                these Terms.
              </p>
            </p>
          </div>
          <div className="flex">
            <p className="pr-5">(d)</p>
            <p className="">
              <span>RESTRICTIONS ON USE OF THE SERVICE</span> <br />
              You shall not yourself or through any third party (i) rent, lease,
              sell, distribute, offer in a service bureau, sublicense, or
              otherwise make available the Service or the Designto any third
              party (except as permitted under these Terms); (ii) copy,
              replicate, decompile, reverse-engineer, attempt to derive the
              source code of, modify, or create derivative works of the Service,
              or any part thereof or to gain access of any Intellectual Property
              of ScrollX thereof, or methods used to compile the Credits, in
              whole or in part; (iii) access the Service for purposes of
              performance benchmarking; (iv) access the Service for purposes of
              building or marketing a competitive product or distribute,
              transfer or otherwise make available the Services (including
              User’s access to its account on website of ScrollX) to any third
              party; (v) use a virtual private network (VPN) to circumvent
              geographic-based pricing or content access; (vi) use the Service
              to transmit or post any viruses, malware, trojans, bugs or other
              disruptive/harmful programs, files or code, unsolicited emails or
              engage in spamming; (vii) upload or insert any programming
              language or code into or onto the ScrollX website or the Service;
              (viii) use any form of data mining, extraction, or scraping on the
              Service and/or the contents available therein for machine learning
              or other purposes; (ix) bypass the measures ScrollX may use to
              prevent or restrict access to the Service as per the applicable
              Fees, including without limitation features that prevent or
              restrict use or copying of any content or enforce limitations on
              use of the Service or the Licensed Content; (x)infringe or violate
              any third party’s Intellectual Property rights; (xi) be libellous,
              threatening, harassing or defamatory, or distribute or promote
              porn, obscene, lewd, or suggestive content; or(xii) violate any
              Applicable Laws.
            </p>
          </div>
        </div>
        {/* 4.	SECURITY AND DATA PRIVACY */}
        <div className="grid  grid-flow-row gap-4 list-decimal list-outside py-5">
          <div className="Syne700 text-2xl flex">
            <h1 className="pr-5">4</h1>
            <h1>SECURITY AND DATA PRIVACY</h1>
          </div>
          <div className="flex">
            <p className="pr-5">(a)</p>
            <p className="">
              <span className="text-xl font-semibold">INFORMATION SECURITY</span>
              <br />
              ScrollX implements and maintains technical,and administrative
              security measures designed to protect your information (including
              User Content) from unauthorized access, destruction, use,
              modification, or disclosure. You can learn more about how ScrollX
              protects the Service and your information at ScrollX’s{" "}
              <span className="underline text-blue-700">
                Privacy Policy.
              </span>{" "}
              Please note that Privacy Policy is an integral part of the Terms,
              and you should review both documents.
            </p>
          </div>
          <div className="flex">
            <p className="pr-5">(b)</p>
            <p>
              <span className="text-xl font-semibold">DATA PRIVACY</span>
              <br />
              ScrollX’s Privacy Policy describes how ScrollX collects, uses,
              transfers, discloses, and stores your personal data. By creating
              an account on ScrollX, you confirm that you have read, understood,
              and agree to ourPrivacy Policy in full. In the event of any
              conflict between these Terms and the Privacy Policy, the Data
              Privacy Policy shall prevail.
            </p>
          </div>
        </div>
        {/* 5.	USER CONTENT AND DESIGNS*/}
        <div className="grid  grid-flow-row gap-4 list-decimal list-outside py-5">
          <div className="Syne700 text-2xl flex">
            <h1 className="pr-5">5</h1>
            <h1>USER CONTENT AND DESIGNS</h1>
          </div>
          <div className="flex">
            <p className="pr-5">(a)</p>
            <p className="">
              <span className="text-xl font-semibold">NO EXPECTATION OF DUE DILIGENCE</span>
              <br />
              You agree and acknowledge that ScrollX merely provides a platform
              for collating yourUser Content for a rendition of usable Credits,
              and as such you agree and warrant to possess ownership MANDATORILY
              and/or all licences/rights (including but not limited to
              Intellectual Property rights) of the User Content. Youagree,
              warrant, and acknowledge that ScrollX neither has the obligation
              nor any duty to check or verify on your behalf, the
              ownership/right/licence of any particular User Content which
              youintend to convert into Credits and as such the sole obligation
              & duty to check, verify & prove the said ownership/right/licence
              of the User Content is yours. It is hereby clarified, and you
              agree that ScrollX shall not be held liable for any User Content
              asset including any name, credit, logo, font submitted and/or
              Credits generated by you.
            </p>
          </div>
          <div className="flex">
            <p className="pr-5">(b)</p>
            <p>
              <span className="text-xl font-semibold">LICENSE</span>
              <br />
              By submitting/sharing the User Content, you hereby grant
              aworldwide, non-exclusive,irrevocable, transferable,royalty free,
              perpetual right & licence to ScrollX to access, use, import,
              export, display, transmit, publish, reproduce, modify, distribute
              and/or create derivative works from the User Content in any format
              at the sole discretion of ScrollX
              <p className="pt-3">
                It is hereby clarified that the User Content shall be deemed to
                be non-proprietary and non-confidential. You agree that ScrollX
                does not pay any compensation, remuneration or award for User
                Content. ScrollX is under no obligation to adopt, adhere or
                respond to the User Content.
              </p>
            </p>
          </div>
          <div className="flex">
            <p className="pr-5">(c)</p>
            <p>
              <span className="text-xl font-semibold">CONSENT AND APPROVAL </span>
              <br />
              You acknowledge and agree that the User Content submitted are
              intended for public display and performance in the form of Credits
              worldwide, and as such you represent and warrant that you have
              received all necessary consents, approvals, rights and licences
              for submitting the User Content on the platform of ScrollX and for
              public display and performance of the resultant Credits
              worldwide.You are not permitted to submit or share the User
              Content which are subjected to third party’s Intellectual Property
              and/or proprietary property, trade secrets, confidential
              information etc. for which you have not availed adequate
              permission or licence. ScrollX disclaims all liability and
              responsibility owing to submission of User Content.
              <p className="pt-3">
                That you are mindful of the fact that the User Content are
                likely to include personally identifiable information (ex.
                Names, title, contact information) of various contributors of
                Project, as such you agree, represent, and warrant that youhave
                all such contributors’ permission/consent to share the
                information with ScrollX.{" "}
              </p>
              <p className="pt-3">
                You hereby agree and warrant to unconditionally indemnify,
                defend and hold harmless ScrollX and its owners, promoters and
                employees etc. against any claim, liability, suit, proceedings,
                actions, demands made by any such contributors regarding misuse
                or misappropriation of their proprietary rights including but
                not limited to rights to their image, name & title.
              </p>
            </p>
          </div>
          <div className="flex">
            <p className="pr-5">(d)</p>
            <p>
              <span className="text-xl font-semibold">PERMISSIONS GRANTED </span>
              <br />
              Subject to your compliance with these Terms and the Privacy
              Policy, ScrollX hereby grants you a worldwide, non-exclusive,
              transferable, and sub-licensable right and licence to use, modify,
              sell, offer for sale, import, export, reproduce, distribute,
              create derivative works of (in the form of Projects), publicly
              perform, publicly display and digitally perform and display the
              Credits generated from User Content. It is hereby clarified that
              the licence to use generated Credits, as mentioned hereinabove,
              does not grant the right or licence to you to share or provide
              access of your account to any other person, third-party or
              organisation.
            </p>
          </div>
          <div className="flex">
            <p className="pr-5">(e)</p>
            <p>
              <span className="text-xl font-semibold">STORAGE AND TRANSFER</span>
              <br />
              You agree and acknowledge that ScrollX may access, store and use
              any User Content that you may provide in order to avail the
              Services and/or generation of Credits, and in accordance with
              ScrollX’s internal policies for data security, Privacy Policy and
              routine backup procedures.
              <p className="pt-3">
                ScrollX may permit you to submit/share the feedback, comments,
                messages, concepts, ideas, technical know-how or other such
                communication through the website. You agree, represent, and
                confirm that you are the rightful owners or have adequate
                permission/licence to submit or share the User Content.{" "}
              </p>
            </p>
          </div>
        </div>
        {/* 6.	FEES AND PAYMENT TERMS */}
        <div className="grid  grid-flow-row gap-4 list-decimal list-outside py-5">
          <div className="Syne700 text-2xl flex">
            <h1 className="pr-5">6</h1>
            <h1>FEES AND PAYMENT TERMS</h1>
          </div>
          <div className="flex">
            <p className="pr-5">(a)</p>
            <p className="">
              <span className="text-xl font-semibold">PAYMENT CONTINGENCY</span>
              <br />
              Your availability of Services and/or licence to use any Credits
              generated through ScrollX is contingent upon full payment of
              relevant fees, including any taxes thereon. Failure to pay the
              required Fees and taxes may result in termination of Services
              and/or termination of licence to use the Credits. The Fees is
              payable based on the plan opted by you and shall be compulsorily
              payable before availment of services/generation of Credits. You
              agree to pay the Fees in the USD.
            </p>
          </div>
          <div className="flex">
            <p className="pr-5">(b)</p>
            <p>
              <span className="text-xl font-semibold">FEES MODIFICATION</span>
              <br />
              ScrollX reserves the right to change or modify the Fees of each
              plan at any time. Any change or modification in the Fees shall be
              solely at the discretion of ScrollX and the same would be updated
              on the website of ScrollX.
            </p>
          </div>
          <div className="flex">
            <p className="pr-5">(c)</p>
            <p>
              <span className="text-xl font-semibold">REFUND</span>
              <br />
              You agree that any refund of Fees will only apply in sparring
              circumstances determinable at the absolute & sole discretion of
              ScrollX. It is hereby clarified that under no circumstance a
              refund would be provided after the Credits are generated or
              exported by you.
            </p>
          </div>
          <div className="flex">
            <p className="pr-5">(d)</p>
            <p>
              <span className="text-xl font-semibold">PAYMENT PROCESSING</span>
              <br />
              It is clarified that the Fees does not include the duties, foreign
              exchange charges or other governmental levies which may incur
              during the payment of Fees by you and as such it is your sole
              responsibility to pay & discharge such duties, foreign exchange
              charges and other governmental levies.
              <p className="pt-3">
                In order to provide a convenient method of payment of Fees,
                ScrollX uses a third party payment processor to collect payments
                through debit cards, credit cards etc. It is hereby clarified
                that while ScrollX does not store your payment information, the
                said third party payment processor may store your payment
                information with your express or implied consent. In such
                circumstances, ScrollX shall not be liable for any data breach
                on account of the said payment processor third party. You agree
                and authorise ScrollX to charge any outstanding Fees or payment
                to your stored payment methods when such Fees or payment becomes
                due.
              </p>
            </p>
          </div>
          <div className="flex">
            <p className="pr-5">(e)</p>
            <p>
              <span className="text-xl font-semibold">MANAGING ACCOUNT LIMIT</span>
              <br />
              You are responsible for managing the usage of the Credits to
              ensure that such usage does not exceed the specific number of
              Credits that can be generated for which you have paid the
              applicable Fees. For further clarity, it is specifically mentioned
              that if you have paid the Fees for generating Credits for one
              specific Project, you would be allowed and are permitted to
              create, design and generate Credits for only that specific Project
              for which the applicable Fees has been paid. ScrollX reserves
              rights to seek additional Fees in case of violation of this clause
              and youshall be obligated to pay the said additional Fees for
              exceeding the credits limit. In addition to seeking additional
              Fees, ScrollX, at its sole discretion, may revoke your licence to
              all the Credits generated by you (including the one for which Fees
              has been paid by the User), suspend your account and take
              appropriate legal action against you.
            </p>
          </div>
        </div>
        {/*7.	SCROLLX’S INTELLECTUAL PROPERTY*/}
        <div className="grid  grid-flow-row gap-4 list-decimal list-outside py-5">
          <div className="Syne700 text-2xl flex">
            <h1 className="pr-5">7</h1>
            <h1>SCROLLX’S INTELLECTUAL PROPERTY</h1>
          </div>
          <div className="flex">
            <p className="pr-5">(a)</p>
            <p className="">
              You acknowledge, warrant, and agree that the Services/provision of
              Credits are made possible because of ScrollX’s software, systems,
              templates and other technology and know-how, that are sole,
              exclusive, and non-transferable Intellectual Property of ScrollX.
              It is hereby clarified, and you acknowledge and warrantthat your
              availment of the Services/Credits does not create, vest, or accrue
              any right, title, or interest in or to any ScrollX’s Intellectual
              Property. You acknowledge that nothing in this Agreement shall
              operate to transfer or assign any right in the Intellectual
              Property from ScrollX to you.
            </p>
          </div>
          <div className="flex">
            <p className="pr-5">(b)</p>
            <p>
              ScrollX is the sole owner of trademarks and/or registered
              trademarks of ‘ScrollX’ in India and in various jurisdictions.You
              agree and acknowledge that the logo of ScrollX and a statement to
              the effect “End Credits by ScrollX” shall be embedded in the
              Credits generated by you and that you shall not attempt to remove
              the said logo and/or statement from the Credits
            </p>
          </div>
        </div>
        {/* 8.	WARRANTY  */}
        <div className="grid  grid-flow-row gap-4 list-decimal list-outside py-5">
          <div className="Syne700 text-2xl flex">
            <h1 className="pr-5">8</h1>
            <h1>WARRANTY </h1>
          </div>
          <div className="flex">
            <p className="pr-5">(a)</p>
            <p className="">
              <span className="text-xl font-semibold">DISCLAIMER</span>
              <br />
              You acknowledge and agree that the Services/Credits are being
              provided on an “as is” and “as available” basis without any
              warranties or representations of any kind whatsoever. Accordingly,
              to the maximum extent permitted by Applicable Laws, ScrollX
              provides the Services/Credits without any warranties of any kind,
              express, implied, statutory, or in any other provision of this
              Agreement or communication with customer, and ScrollX specifically
              disclaim any implied warranties of merchantability, title, fitness
              for a particular purpose and non-infringement.
            </p>
          </div>
          <div className="flex">
            <p className="pr-5">(b)</p>
            <p>
              <span className="text-xl font-semibold">LIMITATION OF LIABILITY </span>
              <br />
              To the maximum extent permitted by Applicable Laws, in no event
              will ScrollX be liable for any lost profits or business
              opportunities, loss of use, business interruption, loss of data,
              or any other indirect, special, incidental, or consequential
              damages under any theory of liability, whether based in contract,
              tort, negligence, product liability, or otherwise. Further, in no
              event shall ScrollX’s liability under this Agreement exceed the
              fees, if any, paid by you for availing the Services/Credits under
              this Agreement.
              <p className="pt-3">
                ScrollX assumes no liability or responsibility for any (i)
                Viruses, Bugs, Trojan Horses or other destructive/harmful
                computer codes or the like which may be transmitted through
                accessing the website and/or availment of Services/generation of
                Credits; (ii) Interruption or cessation of accessing the website
                and/or availment of Services/Credits; (iii) Unauthorised access
                to or use of the account created by you on the website of
                ScrollX; (iv) Unauthorised access to or use of the
                information/User Content stored by you on the website of
                ScrollX; (v) loss or damage of any kind incurred as a result of
                the use or distribution of Credits; (vi) damage to the property,
                including but not limited to loss of data or corruption; (vii)
                errors, mistakes or inaccuracies of any kind in the Credits; and
                (ix) changes made by ScrollX in its services, features or
                products.
              </p>
            </p>
          </div>
          <div className="flex">
            <p className="pr-5">(c)</p>
            <p>
              <span className="text-xl font-semibold">MAINTENANCE AND SERVICE INTERRUPTIONS</span>
              <br />
              You acknowledge that the use of website/Services may be halted due
              to maintenance and would not be considered as breach of this
              Agreement. ScrollX would endeavour, however, does not assure or
              guarantee, that all maintenance will be carried outside business
              hours.
              <p className="pt-3">
                You agree and acknowledge that being a complex software and
                nascent technology, ScrollX gives no warranty or representation
                that the Services/Credits will be wholly free from bugs, defects
                &errors. You further agree and acknowledge that in this modern
                age of technology, software’s are never entirely free from
                security vulnerabilities, as such ScrollX gives no warranty or
                representation that the Services/Credits will be entirely
                secure.
              </p>
              <p className="pt-3">
                Out of abundant caution, it is hereby clarified that any planned
                or unplanned downtime caused directly or indirectly by any of
                the following events shall not be considered a breach of this
                Agreement: <br />
                any breach by you of terms and conditions of this Agreement; or{" "}
                <br />
                ii. occurrence of any Force Majeure Event; or <br />
                iii. due to failure or fault of telecommunication network or
                internet; or <br />
                iv. Maintenance carried out by ScrollX.
              </p>
            </p>
          </div>
        </div>
        {/* 9.	INDEMNIFICATION */}
        <div className="grid  grid-flow-row gap-4 list-decimal list-outside py-5">
          <div className="Syne700 text-2xl flex">
            <h1 className="pr-5">9</h1>
            <h1>INDEMNIFICATION</h1>
          </div>
          <div className="flex">
            <p className="pr-5">(a)</p>
            <p className="">
              You (“Indemnifying Party”) agrees to indemnify, defend, and hold
              ScrollX, its promoters, directors, agents, and employees (each, an
              “Indemnitee” and collectively, the “Indemnitees”) harmless from
              and against any and all liabilities, damages, losses, expenses,
              claims, demands, suits, fines, judgments including reasonable
              attorneys’ fees, costs, and expenses incidental thereto, arising
              out of or relating to your negligence, breach of this Agreement,
              violation of any law or right, and infringement of third party’s
              Intellectual Property rights. It is expressly agreed to between
              you and ScrollX that ScrollX will not be responsible for causes or
              actions brought forth by a third party due to availment of
              Services/Credits by you. You agree to indemnify and hold ScrollX
              and its owners, promoters, and employees etc. harmless to the
              fullest extent allowed by Applicable Law regarding all matters
              related to or arising out of your submission of the User Content.
            </p>
          </div>
        </div>
        {/* 10.	TERM AND TERMINATION */}
        <div className="grid  grid-flow-row gap-4 list-decimal list-outside py-5">
          <div className="Syne700 text-2xl flex">
            <h1 className="pr-5">10</h1>
            <h1>TERM AND TERMINATION</h1>
          </div>
          <div className="flex">
            <p className="pr-5">(a)</p>
            <p className="">
              These Terms shall take effect the first time you access the
              Service and shall continue in full force and effect until youhave
              a paid account with ScrollX till the expiration or termination of
              your account.
            </p>
          </div>
          <div className="flex">
            <p className="pr-5">(b)</p>
            <p>
              If ScrollX, in its reasonable discretion, determines that you or
              your use of the Service, your User Content, or your Designs
              violate these Terms, including but not limited to, the Section
              entitled ‘Restrictions on Use of the Service’, ScrollX may take
              one or more of the following actions: (i) delete the prohibited
              User Content or Designs; (ii) suspend your access to the Service;
              (iii) terminate and delete your account along with all Designs and
              User Content associated with that account (iv) permanently ban you
              from using the Service; and/or (v) disclose the prohibited User
              Content or Designs to appropriate government authorities.
            </p>
          </div>
          <div className="flex">
            <p className="pr-5">(c)</p>
            <p>
              ScrollX reserves the unilateral right to revoke your licence to
              the Credits if ScrollX determines that you have generated/used the
              Credits or the Services in violation of the terms and conditions
              of this Agreement OR determine/any third party alleges that the
              use of Services or the Credits infringes any person’s Intellectual
              Property rights. You, wilfully and without any coercion, duress or
              undue influence, agree & acknowledges that the decision of ScrollX
              in revoking your licence to the Credits will be final and binding
              on you and you shall not contest/challenge/appeal the said
              decision in any court, tribunal, arbitration or any other forum.
            </p>
          </div>
          <div className="flex">
            <p className="pr-5">(d)</p>
            <p>
              Upon any expiration or termination of your account, you must cease
              using the Service. You will lose access to your Designs, User
              Content, and any other information uploaded to the Service (and we
              may delete all such data unless legally prohibited) after
              expiration or termination of your account. User Content included
              in any shared Design will continue to be available within that
              Design even after the expiration of your account. Unless your
              account is terminated due to a Violation, you can download or
              export your User Content and Designs using the functionality of
              the Service prior to the expiration or termination of your
              subscription. If your account has been terminated due to a
              Violation, you may not create a new account on any ScrollX Service
              unless you receive ScrollX’s written permission.
            </p>
          </div>
        </div>
        {/*11.	GENERAL*/}
        <div className="grid  grid-flow-row gap-4 list-decimal list-outside py-5">
          <div className="Syne700 text-2xl flex">
            <h1 className="pr-5">11</h1>
            <h1>GENERAL</h1>
          </div>
          <div className="flex">
            <p className="pr-5">(a)</p>
            <p className="">
              <span className="text-xl font-semibold">ENTIRE AGREEMENT</span> 
              <br />
              These Terms constitutes the entire agreement on the matters
              specified herein, and supersedes all prior oral and written
              understandings, between you and ScrollX regarding the subject
              matter hereof. Any modification or addition or amendment to these
              Terms shall be caused by ScrollX without the obligation of prior
              disclosure/notice to you. You are expected to visit these Terms on
              a regular basis to ascertain changes & amendments, if any.
            </p>
          </div>
          <div className="flex">
            <p className="pr-5">(b)</p>
            <p>
              <span className="text-xl font-semibold">NOTICE & COMMUNICATION</span>
              <br />
              You authorise ScrollX to use the contact information provided by
              you while making an account on the website, to provide you with
              important communication/notices at its sole discretion.
            </p>
          </div>
          <div className="flex">
            <p className="pr-5">(c)</p>
            <p>
              <span className="text-xl font-semibold">WAIVER</span> <br />
              If ScrollX fails to enforce any right or remedy available under
              this Agreement, that failure will not be construed as a waiver of
              any right or remedy with respect to any other breach or failure by
              the other Party.
            </p>
          </div>
          <div className="flex">
            <p className="pr-5">(d)</p>
            <p>
              <span className="text-xl font-semibold">NO AGENCY</span>
              <br />
              Nothing in these Terms shall deem to confer any agency, joint
              venture, partnership, employee-employer, or franchisor-franchisee
              relationship between you and ScrollX.
            </p>
          </div>
          <div className="flex">
            <p className="pr-5">(e)</p>
            <p>
              <span className="text-xl font-semibold">SEVERABILITY</span>
              <br />
              If any portion of this Agreement is found by a court of competent
              jurisdiction to be invalid or unenforceable, that provision of the
              Agreement will be amended to achieve as nearly as possible the
              intent of the parties, and the remainder of this Agreement will
              remain in full force and effect.
            </p>
          </div>
          <div className="flex">
            <p className="pr-5">(f)</p>
            <p>
              <span className="text-xl font-semibold">MODIFICATION TO THESE TERMS</span>
              <br />
              ScrollX retains the right to modify these Terms (including any
              referenced policies) at its discretion. The latest version of
              these Terms will be available on our official website. If there
              are changes that we determine, at our sole discretion, will
              materially impact your rights or your use of the Service,
              ScrollXwill provide you with reasonable advance notice. This
              notice may be delivered through the Service and/or via email to
              the address linked to your account. Your continued use of the
              Service following the implementation of revised Terms constitutes
              your acceptance and agreement to be bound by the updated Terms.
            </p>
          </div>
          <div className="flex">
            <p className="pr-5">(g)</p>
            <p>
              <span className="text-xl font-semibold">CHANGES TO THE SERVICE</span>
              <br />
              ScrollX reserves the right to enhance, modify, or discontinue
              features or functionality within the Service at its discretion.
              This may include changes to credits limit or the removal of
              certain features. In the event of Service discontinuation, if you
              are subscribed to a paid account, ScrollX shall either migrate you
              to a substantially similar service (if available) or provide a
              pro-rata refund for the remaining subscription period if an
              alternative service cannot be offered.
            </p>
          </div>
          <div className="flex">
            <p className="pr-5">(h)</p>
            <p>
              <span className="text-xl font-semibold">GOVERNING LAW AND DISPUTE RESOLUTION</span>
              <br />
              <p>
                i. TheseTerms (including the Privacy Policy) shall be governed
                by and interpreted and in accordance with the laws of India.The
                courts at Bhopal, Madhya Pradesh, India shall have exclusive
                jurisdiction to entertain any dispute that may arise between you
                and ScrollXrelated to this Agreement
              </p>
              <p className="pt-3">
                ii. In the event of any dispute arising out of or in connection
                with this Agreement, including any question regarding its
                existence, validity, or termination, shall be first settled
                amicably by you and ScrollX.{" "}
              </p>
              <p className="pt-3">
                iii. If you and ScrollX are unable to resolve the dispute within
                a period of 60 (sixty) days from the date of such reference, the
                dispute shall be referred to and finally reserved by an arbitral
                tribunal that shall comprise of three (3) arbitrators. Both you
                and ScrollX shall appoint one arbitrator each and the two
                arbitrators shall appoint the Chairman-arbitrator of the
                Arbitral Tribunal. The Arbitration shall be conducted in English
                language in accordance with the provisions of the Indian
                Arbitration and Conciliation Act, 1996, or its statutory
                amendments thereof. The award passed by the arbitrators shall be
                final and binding on you and ScrollX.{" "}
              </p>
              <p className="pt-3">
                iv. The costs of arbitration shall be bornein equal proportions
                by you and ScrollX. The seat/place/venue of arbitration shall be
                at such place in India as mutually agreed upon by you and
                ScrollX.
              </p>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
